import React, { useState, useEffect } from 'react';
import { X, Save } from 'lucide-react';
import './ThresholdModal.css';

interface WebhookModalProps {
  webhookUrl: string;
  onSave: (webhookUrl: string | null) => void;
  onClose: () => void;
}

const WebhookModal: React.FC<WebhookModalProps> = ({
  webhookUrl,
  onSave,
  onClose
}) => {
  const [webhook, setWebhook] = useState(webhookUrl);

  useEffect(() => {
    setWebhook(webhookUrl);
  }, [webhookUrl]);

  const handleSave = () => {
    onSave(webhook || null);
  };

  return (
    <div className="threshold-modal-overlay" onClick={onClose}>
      <div className="threshold-modal" onClick={(e) => e.stopPropagation()}>
        <div className="threshold-modal-header">
          <h2>Webhook Settings</h2>
          <button className="close-button" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="threshold-modal-content">
          <div className="threshold-explanation">
            <p>Configure a webhook URL to receive notifications when profile status changes.</p>
          </div>

          <div className="threshold-controls">
            <div className="threshold-section">
              <label className="threshold-label">Webhook URL</label>
              <input
                type="url"
                value={webhook}
                onChange={(e) => setWebhook(e.target.value)}
                placeholder="https://your-webhook-url.com/endpoint"
                className="webhook-input"
              />
              <p className="webhook-help">
                Webhook URL where status updates will be sent. Leave empty to disable webhooks.
              </p>
            </div>
          </div>
        </div>

        <div className="threshold-modal-footer">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="save-button" onClick={handleSave}>
            <Save size={16} />
            Save Webhook
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebhookModal;

